import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { APP_URLS } from "./constants";

// The site is a single-page Home with two ancillary legal pages.  Each
// owns its own chrome (Nav + Footer) via the shared exports from Home.js.
const Home       = React.lazy(() => import("./views/Home"));
const PolicyPage = React.lazy(() => import("./views/Legal/PolicyPage"));
const TermsPage  = React.lazy(() => import("./views/Legal/TermsPage"));

/**
 * Themed splash shown while React.lazy resolves the Home chunk on a fresh
 * reload.  Reads the user's dark-mode preference from localStorage so the
 * splash background matches whichever theme they last used — no jarring
 * white flash before dark-mode content appears.  A subtle pulsing "A"
 * mark keeps it feeling alive rather than blank.
 */
function readDarkPref() {
  try {
    if (typeof window !== "undefined") {
      const v = window.localStorage.getItem("asrit-home-dark");
      return v === "true";
    }
  } catch (e) { /* ignore */ }
  return false;
}

const Loading = () => {
  const dark = readDarkPref();
  const bg = dark ? "#070D1A" : "#F5FAFF";
  return (
    <div style={{
      minHeight: "100vh",
      background: bg,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "background .2s",
    }}>
      <svg viewBox="0 0 64 64" width="72" height="72" aria-label="Loading"
        style={{ animation: "asritSplashPulse 1.6s ease-in-out infinite" }}>
        <defs>
          <linearGradient id="asritSplashG" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%"  stopColor="#00AEEF"/>
            <stop offset="55%" stopColor="#6366F1"/>
            <stop offset="100%" stopColor="#8B5CF6"/>
          </linearGradient>
        </defs>
        <polygon points="18,15 36,12 28,40 16,42" fill="url(#asritSplashG)"/>
        <circle cx="15" cy="49" r="5" fill="url(#asritSplashG)"/>
      </svg>
      <style>{`
        @keyframes asritSplashPulse {
          0%,100% { opacity: 0.55; transform: scale(1); }
          50%     { opacity: 1;    transform: scale(1.08); }
        }
      `}</style>
    </div>
  );
};

class App extends Component {
  render() {
    return (
      <Router>
        <React.Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path={APP_URLS.HOME}   render={() => <Home />} />
            <Route exact path={APP_URLS.POLICY} render={() => <PolicyPage />} />
            <Route exact path={APP_URLS.TERMS}  render={() => <TermsPage />} />
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;
